import axios from '@plugins/axios';
import getSecret from '@utils/get-secret';

let serverUrl = getSecret('SERVER_URL');

export const state = {
  cached: {},
  products: [], 
};

export const getters = {};

export const mutations = {
  REPORTS_MANAGEMENT(state, reports_management) {
    state.cached = reports_management;
  },
  PRODUCTS_LIST(state, products) {
    state.products = products;
  },
};

export const actions = {
  init({ state, dispatch }) {},
  
  fetchProducts(context, query) {
    query = query || '';
    return axios
      .get(`${serverUrl}/euro_inventory_invoices/products/${query}`)
      .then((response) => {
        const products = response.data;
        context.commit('PRODUCTS_LIST', products); 
        return products;
      });
  },
  
  fetchCashOptions(context, query) {
    query = query || '';
    return axios
      .get(`${serverUrl}/euro_captacion/options_cash/${query}`)
      .then((response) => {
        return response.data;
      });
  },
  
  fetchReportManagement(context, query) {
    query = query || '';
    return axios.get(`${serverUrl}/euro_habeas_data/report/${query}`)
      .then((response) => {
        const request = response.data;
        context.commit('REPORTS_MANAGEMENT', request);
        return request;
      });
  },
  
  processExcelData(context, formData) {
    const endpoint = `${serverUrl}/euro_inventory_invoices/products/process_excel_data/`;
    return axios.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  fetchProductsExcel(context, query) {
    query = query || '';
    return axios
      .get(`${serverUrl}/euro_inventory_invoices/products/generate_excel_report/${query}`, {
        responseType: 'arraybuffer',  
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  },
  
  manualCreateProductsHomologated(context, formData) {
    let promise = null
    promise =  axios.post(`${serverUrl}/euro_inventory_invoices/products/create_homologated_data/`, formData)
    return promise.then(
      (response) => {
        return response
      }
    )
  },
  
};